import { Box, Modal, Typography, Divider, Stack, Button, useTheme } from "@mui/material";
import React from "react";
import { TokenPageDataRes } from "src/store/features/api/generated";
import { toggleSummeryView, useTargetState } from "src/store/features/TargetOrders.slice";
import { useAppDispatch } from "src/store/store";
import { formatCurrency } from "src/utils/helpers/PriceAndUnitsHelpers";
import { Link } from "react-router-dom";
import { trackEvent } from "src/Amplitude";
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "583px",
  height: "302px",
  borderRadius: "10px",
  bgcolor: "background.paper",
  boxShadow: 24,
};

interface CloseProps {
  open: boolean;
  price?: TokenPageDataRes;
  handleClose: React.Dispatch<React.SetStateAction<boolean>>;
  handleOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const TargetOrderCloseModal = (props: CloseProps) => {
  const { open, handleClose, price } = props;
  //-------------------------REDUX-------------------
  const dispatch = useAppDispatch();
  const { targetPrice, orderType, tradeAmount, selectedToken, selectedCurrency } = useTargetState();
  //-------------------------STYLES-------------------
  const theme = useTheme();
  //-------------------------CONSTS-------------------
  const formatPriceFloat = price ? price.price : 0;
  const formatPrice = formatCurrency(
    formatPriceFloat,
    selectedCurrency.type === "Fiat" ? selectedCurrency.code : "USD",
  );
  const TITLE = "Target Within 10% of Market Price";
  const CONFIRMATION = "Please confirm that you want to place this target.";
  const WARNING_INFO = ` The current market price of ${
    selectedToken.code
  } is approximately ${formatPrice}. You are requesting to ${
    orderType[0]
  } ${tradeAmount} units of ${selectedToken.code} at the target price of ${formatCurrency(
    targetPrice || 0,
    selectedCurrency.type === "Fiat" ? selectedCurrency.code : "USD",
  )}`;
  const REDIRECT_MESSAGE =
    "If you would like to place this target at market price instead,please click";

  return (
    <Modal
      open={open}
      onClose={() => handleClose(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box sx={style}>
        <Typography
          sx={{
            fontSize: "23px",
            fontWeight: 600,
            padding: "24px 24px 11.5px 24px",
          }}>
          {TITLE}
        </Typography>
        <Divider sx={{ marginRight: "24px", marginLeft: "24px" }} />
        <Typography
          id="modal-modal-description"
          sx={{
            mt: 2,
            padding: "0px 24px 12px 24px",
            fontSize: "14px",
            fontWeight: 600,
            color: theme.palette.secondary.main,
          }}>
          {CONFIRMATION}
        </Typography>
        <Typography
          id="modal-modal-description"
          sx={{
            padding: "0 24px 0px 24px",
            fontSize: "14px",

            textDecoration: "underline",
          }}>
          Your target order is within 10% of the current market price:
        </Typography>
        <Typography
          id="modal-modal-description"
          sx={{
            padding: "0 24px 0 24px",
            fontSize: "14px",
            lineHeight: 1.21,
          }}>
          {WARNING_INFO}
        </Typography>
        <Typography
          id="modal-modal-description"
          sx={{
            padding: "12px 24px 0 24px",
            fontWeight: 600,
            fontSize: "14px",
            color: "#baae91",
          }}>
          {REDIRECT_MESSAGE}
          <Link to={"/trade"}> here.</Link>
        </Typography>
        <Stack spacing={1} direction="row" sx={{ width: "100%", padding: "24px 24px 0 24px" }}>
          <Button
            disableRipple
            onClick={() => handleClose(false)}
            sx={{ width: "100%" }}
            variant="outlined">
            Cancel
          </Button>
          <Button
            disableRipple
            sx={{
              width: "100%",
              boxShadow: "none",
              backgroundColor: theme.palette.secondary.main,
              "&: hover": {
                backgroundColor: "#fedbdb",
                opacity: "10",
                boxShadow: "none",
              },
            }}
            variant="contained"
            onClick={() => {
              dispatch(toggleSummeryView());
              handleClose(false);
              trackEvent("Select_Target_Order_Next_Button_Warning_Modal_Confirm_Price");
            }}>
            Confirm Price
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default TargetOrderCloseModal;
